import Api from "./Api";
import { createQueryString } from "./ApiHelper";
export default {
  ListAllModules(payload) {
    return Api().post(`/allmodules`, payload);
  },
  // ViewPerma(payload) {
  //     return Api().post(`/viewperma`, payload)
  // },

  /** Update Or Add new permissions */
  AddPermission(payload) {
    return Api().post(`/api/admin/permissions`, payload);
  },

  AddUser(payload) {
    return Api().post(`/users`, payload);
  },
  ListAllUser(payload, body) {
    // console.log('payload and body ::', payload, '--------------', body)
    const query = createQueryString(body);
    return Api().get(`/users${query}`, payload);
  },
  ListAllAggregatorUser(payload, body) {
    return Api().get(
      `/aggregator-users?limit=${body.limit}&currentPage=${body.currentPage}&searchValue=${body.searchValue}&orderBy=${body.orderBy}&columnName=${body.columnName}`,
      payload
    );
  },
  ReadAUser(payload) {
    return Api().get(`/users/${payload}`);
  },
  GetUserDetails(payload) {
    return Api().get(`/users/${payload.user_id}`);
  },
  UpdateAUser(payload) {
    return Api().put(`/users/${payload.user_id}`, payload);
  },
  //userslogin
  LoginUser(payload) {
    return Api().post(`/userslogin`, payload);
  },
  checkUserLoggedIn(payload) {
    return Api().post(`/user/check`, payload);
  },

  //Global-userslogin
  GlobalLoginUser(payload) {
    return Api().post(`/api/admin/global_login`, payload);
  },

  CheckUserPassword(payload) {
    return Api().post("/userpasswordconfirm", payload);
  },
  removeToken() {
    return Api().put("/users");
  },
  //Saif
  ForgetPassword(payload) {
    return Api().post("/api/admin/forgetpassword", payload);
  },
  VerifyUsername(payload) {
    return Api().post("/verifyusername", payload);
  },
  OTPExpiry(payload) {
    return Api().post("/otpexpiry", payload);
  },
  VerifyOTP(payload) {
    return Api().post("/verifyotp", payload);
  },
  AddRenunciation(payload) {
    return Api().post("/renunciation", payload);
  },
  GetRenunciation(payload) {
    return Api().get(
      "/renunciation?limit=" +
        payload.limit +
        "&currentPage=" +
        payload.currentPage +
        "&columnName=" +
        payload.columnName +
        "&orderBy=" +
        payload.orderBy
    );
  },
  VerifyCurrentPassword(payload) {
    return Api().post("/verifypassword", payload);
  },
  UpdateChangePassword(payload) {
    return Api().post("/updatechangepassword", payload);
  },
  UpdatePasswordPin(payload) {
    return Api().post("/updatepasswordpin", payload);
  },
  CreateNewToken(payload) {
    return Api().post("/addnewtoken", payload);
  },
  EjsViewer() {
    return Api().get("/ejsdesign");
  },
  GenerateQrCode(payload) {
    return Api().post("/twoFactorQrCode", payload);
  },
  Check2FAEnabled(payload) {
    return Api().post(`/check2FAEnabled`, payload);
  },
  CheckOnlyAuthenticatorEnabled(payload) {
    return Api().post(`/checkOnlyAuthenticatorEnabled`, payload);
  },
  GetAuthenticatorCode() {
    return Api().get(`/authenticator-code`);
  },
  ModulesList(){
    return Api().get(`/module-list`);

  }
};



// WEBPACK FOOTER //
// ./src/services/UserService.js